import { Component, Event, EventEmitter, h, State } from '@stencil/core';
import { httpsCallable } from 'firebase/functions';

import { FirebaseService } from '../../utils/firebase';
import { settings } from '../../store/settings.store';
import { customer } from '../../store/customer.store';
import { customerFields, onCustomerFieldsChange, startCustomerFieldsListener, stopCustomerFieldsListener } from '../../store/customer-fields.store';

import { addCustomFieldToForm, getCustomFieldValues, getFormErrors, handleFormFieldChange, renderCustomerFields, renderField } from '../../utils/form';

import { CustomerCreateRequest, CustomerCreateResponse } from '@artask/tambr-models/models/customer.model';



@Component({
  tag: 'tambr-auth-complete',
  styleUrl: 'tambr-auth-complete.css',
  shadow: false,
})
export class TambrAuthComplete {

  @State() loading: boolean;
  @State() errorMessages: string[] = [];

  @Event() tambrAuthClose: EventEmitter;

  form = {
    firstName: { type: 'text', title: 'First Name', value: '', isRequired: true },
    lastName: { type: 'text', title: 'Last Name', value: '', isRequired: true },
    phone: { type: 'text', title: 'Phone', value: '', isRequired: true },
    subscribed: { type: 'checkbox', title: 'Subscribed', value: false, isRequired: false }
  }

  componentWillLoad() {
    if ( customer.platformCustomer ) {
      this.form.firstName.value = customer.platformCustomer.firstName;
      this.form.lastName.value = customer.platformCustomer.lastName;
      this.form.phone.value = customer.platformCustomer.phone;
    }
    
    startCustomerFieldsListener();

    onCustomerFieldsChange( 'customFields', customFields => {
      for ( let customField of customFields ) {
        addCustomFieldToForm( this.form, customField );
      }
    });
  }

  disconnectedCallback() {
    stopCustomerFieldsListener();
  }

  close() { this.tambrAuthClose.emit(); }

  async logout() { 
    try {
      await FirebaseService.auth.signOut(); 
    } catch (e) {
      console.log(e);
    }
  }

  addErrorMessage( message: string ) { this.errorMessages = [ ...this.errorMessages, message ]; }

  async handleFormSubmit( ev: any ) {
    ev.preventDefault();
    if ( !customer.user ) return;
    this.errorMessages = getFormErrors( this.form );
    if ( this.errorMessages.length ) return;
    this.loading = true;
    
    try {
      const customerData: CustomerCreateRequest = {
        businessId: settings.businessId,
        email: customer.user.email,
        phone: this.form.phone.value,
        lastName: this.form.lastName.value,
        firstName: this.form.firstName.value,
        subscribed: this.form.subscribed.value
      }

      const customerFieldsValues = getCustomFieldValues( this.form, customerFields.customFields );

      if ( customerFieldsValues.length ) {
        customerData.customFields = customerFieldsValues;
      }

      const createCustomer = httpsCallable
        <CustomerCreateRequest, CustomerCreateResponse>
          ( FirebaseService.functions, 'widget_createCustomer' );
        
      await createCustomer( customerData );
      this.loading = false;
      
    } catch ( error ) { 
      this.loading = false;
      this.addErrorMessage( error.message ); 
    }    
  }


  render() {
    return (
      <div class='tambr-modal-window login-window'> 
        <div class='tambr-modal-header'>
          <tambr-icon type='close' class='close-button' onClick={ () => this.close() } />
        </div>

        <div class='tambr-modal-title'>Welcome to { settings.businessSettings.businessName }</div>

        <div class='tambr-modal-logout'>
          <div class='tambr-modal-logout-link' onClick={ () => this.logout() }>Log out</div>        
        </div>

        <div class='tambr-modal-body'>{ this.renderForm() }</div>
      </div>
    );
  }

  renderForm() {
    return (
      <form id='tambr-auth-complete-form' class='tambr-auth-form' onSubmit={ ev => this.handleFormSubmit(ev) }>
        <p>Please fill in the form below to complete your account set up:</p><br></br>           
        
        <div class='sticky-messages'>
          <div class={ 'error message' + (this.errorMessages.length ? ' show' : '') }>
            <ul>{ this.errorMessages.map( ( message: string ) => <li>{ message }</li> ) }</ul> 
          </div>
        </div>

        <div class='tambr-form-grid'>
          { renderField( this.form, { id: 'firstName', title: 'First Name', type: 'text', isRequired: true } ) }
          { renderField( this.form, { id: 'lastName', title: 'Last Name', type: 'text', isRequired: true } ) }
          { renderField( this.form, { id: 'phone', title: 'Phone', type: 'text', isRequired: true } ) }
        </div>

        { renderCustomerFields( this.form ) }
        
        <div class='checkbox-wrapper'>
          <input type='checkbox' id='subscribe-checkbox' name='subscribe-checkbox' checked={ this.form.subscribed.value } 
            onInput={ (event) => handleFormFieldChange( this.form, event, 'subscribed', true ) } />
          <label htmlFor='subscribe-checkbox'>{`I would like to join ${ settings.businessSettings.businessName } mailing list.`}</label>
        </div>

        <div class='tambr-action-buttons'>
          <button type='submit' disabled={ this.loading } class={ 'tambr-button' + (this.loading ? ' loading' : '') }>
            <div class='tambr-button-loading'><div>Loading...</div></div>
            <span>Continue</span>
          </button>
        </div>
      </form>
    )
  }

}
